module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "healthReporting paddingTop45"
  }, [_c('x-header', {
    staticClass: "zdyheaderBlue",
    attrs: {
      "left-options": {
        showBack: false
      }
    }
  }, [_vm._v("健康情况申报卡")]), _vm._v(" "), _c('h3', [_vm._v("就诊人员个人健康情况申报卡")]), _vm._v(" "), (_vm.basedata.canSave == 1 || _vm.basedata.id) ? _c('div', [_c('p', {
    staticClass: "detail"
  }, [_vm._v("\n      您好！为有效防控新型冠状病毒感染的肺炎疫情，确保您和他人的健康，请如实填报您近期的健康状况，非常感谢！\n    ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.lookIf),
      expression: "!lookIf"
    }],
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold",
      "color": "red",
      "text-align": "center",
      "margin": "5px 0 10px"
    }
  }, [_vm._v("今日已申报")]), _vm._v(" "), _c('grid', {
    attrs: {
      "show-lr-borders": false
    }
  }, [_c('grid-item', [_c('x-input', {
    staticClass: "inputClick",
    attrs: {
      "readonly": _vm.getmsg.xm != '',
      "placeholder": "姓名"
    },
    on: {
      "on-change": _vm.iftrim
    },
    model: {
      value: (_vm.basedata.xm),
      callback: function($$v) {
        _vm.$set(_vm.basedata, "xm", $$v)
      },
      expression: "basedata.xm"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconArry.xmIcon),
      expression: "iconArry.xmIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1), _vm._v(" "), _c('grid-item', [_c('x-input', {
    staticClass: "inputClick",
    attrs: {
      "text-align": "right",
      "readonly": _vm.getmsg.tel != '',
      "keyboard": "number",
      "placeholder": "联系电话"
    },
    on: {
      "on-blur": _vm.telvaite
    },
    model: {
      value: (_vm.basedata.tel),
      callback: function($$v) {
        _vm.$set(_vm.basedata, "tel", $$v)
      },
      expression: "basedata.tel"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconArry.telIcon),
      expression: "iconArry.telIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1)], 1), _vm._v(" "), _c('grid', {
    attrs: {
      "show-lr-borders": false
    }
  }, [_c('grid-item', [_c('checklist', {
    staticClass: "checklist2",
    attrs: {
      "max": 1,
      "disabled": !_vm.lookIf,
      "label-position": "right",
      "options": _vm.hzlxList
    },
    on: {
      "on-change": function($event) {
        _vm.Listchange('hzlx')
      }
    },
    model: {
      value: (_vm.hzlx),
      callback: function($$v) {
        _vm.hzlx = $$v
      },
      expression: "hzlx"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconArry.hzlxIcon),
      expression: "iconArry.hzlxIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1)], 1), _vm._v(" "), _c('grid', {
    attrs: {
      "show-lr-borders": false
    }
  }, [_c('grid-item', [_c('x-input', {
    staticClass: "inputClick",
    attrs: {
      "readonly": _vm.getmsg.sfzh != '',
      "placeholder": "身份证号"
    },
    on: {
      "on-blur": _vm.SFZvalidate
    },
    model: {
      value: (_vm.basedata.sfzh),
      callback: function($$v) {
        _vm.$set(_vm.basedata, "sfzh", $$v)
      },
      expression: "basedata.sfzh"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconArry.sfzhIcon),
      expression: "iconArry.sfzhIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1)], 1), _vm._v(" "), _c('group-title', {
    attrs: {
      "id": "one"
    }
  }, [_vm._v("1.过去14天到现在，您是否有以下症状，请勾选相应选项")]), _vm._v(" "), _c('div', {
    staticClass: "relative"
  }, [_c('checklist', {
    staticClass: "checklist2",
    attrs: {
      "disabled": !_vm.lookIf,
      "label-position": "right",
      "options": _vm.commonList
    },
    on: {
      "on-change": _vm.zhengzhuangChange
    },
    model: {
      value: (_vm.zhengzhuang),
      callback: function($$v) {
        _vm.zhengzhuang = $$v
      },
      expression: "zhengzhuang"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconArry.zhengzhuangIcon),
      expression: "iconArry.zhengzhuangIcon"
    }],
    staticClass: "warnIcon",
    staticStyle: {
      "bottom": "15px",
      "top": "auto"
    },
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.otherzhengzhuangShow),
      expression: "otherzhengzhuangShow"
    }],
    staticClass: "relative"
  }, [_c('x-input', {
    staticClass: "inputClick",
    attrs: {
      "text-align": "left",
      "readonly": !_vm.lookIf,
      "placeholder": "请填写其他症状说明"
    },
    on: {
      "on-change": _vm.zzQtzzSmChange
    },
    model: {
      value: (_vm.basedata.zzQtzzSm),
      callback: function($$v) {
        _vm.$set(_vm.basedata, "zzQtzzSm", $$v)
      },
      expression: "basedata.zzQtzzSm"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.zzQtzzSmIcon),
      expression: "zzQtzzSmIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nozhengzhuangShow),
      expression: "nozhengzhuangShow"
    }],
    staticClass: "relative"
  }, [_c('x-input', {
    staticClass: "inputClick",
    attrs: {
      "text-align": "left",
      "readonly": !_vm.lookIf,
      "placeholder": "请填写症状"
    },
    model: {
      value: (_vm.basedata.zzWsszzSm),
      callback: function($$v) {
        _vm.$set(_vm.basedata, "zzWsszzSm", $$v)
      },
      expression: "basedata.zzWsszzSm"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.zzWsszzSmIcon),
      expression: "zzWsszzSmIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1), _vm._v(" "), _c('group-title', [_vm._v("2.过去14天内是否有过境外的旅行史或居住史？")]), _vm._v(" "), _c('div', {
    staticClass: "relative"
  }, [_c('checklist', {
    staticClass: "checklist2",
    attrs: {
      "max": 1,
      "disabled": !_vm.lookIf,
      "label-position": "right",
      "options": _vm.List
    },
    on: {
      "on-change": _vm.zljsChange
    },
    model: {
      value: (_vm.hbljs),
      callback: function($$v) {
        _vm.hbljs = $$v
      },
      expression: "hbljs"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconArry.hbljsIcon),
      expression: "iconArry.hbljsIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.jiechudateShow),
      expression: "jiechudateShow"
    }],
    staticClass: "relative"
  }, [_c('datetime', {
    attrs: {
      "readonly": !_vm.lookIf,
      "placeholder": "请选择",
      "format": "YYYY-MM-DD",
      "title": "返蓉时间"
    },
    on: {
      "on-change": _vm.iftrim
    },
    model: {
      value: (_vm.basedata.hbljsFrsj),
      callback: function($$v) {
        _vm.$set(_vm.basedata, "hbljsFrsj", $$v)
      },
      expression: "basedata.hbljsFrsj"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hbljsFrsjIcon),
      expression: "hbljsFrsjIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1), _vm._v(" "), _c('group-title', {
    attrs: {
      "id": "two"
    }
  }, [_vm._v("3.过去14天内是否接触过境外或境内新型冠状病毒感染的病例？")]), _vm._v(" "), _c('div', {
    staticClass: "relative"
  }, [_c('checklist', {
    staticClass: "checklist2",
    attrs: {
      "max": 1,
      "disabled": !_vm.lookIf,
      "label-position": "right",
      "options": _vm.List
    },
    on: {
      "on-change": function($event) {
        _vm.Listchange('jzggzbdry')
      }
    },
    model: {
      value: (_vm.jzggzbdry),
      callback: function($$v) {
        _vm.jzggzbdry = $$v
      },
      expression: "jzggzbdry"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconArry.jzggzbdryIcon),
      expression: "iconArry.jzggzbdryIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1), _vm._v(" "), _c('group-title', {
    attrs: {
      "id": "two"
    }
  }, [_vm._v("4.过去14天内周围（包括所在小区）是否有疑似或确诊新型冠状病毒肺炎患者？")]), _vm._v(" "), _c('div', {
    staticClass: "relative"
  }, [_c('checklist', {
    staticClass: "checklist2",
    attrs: {
      "max": 1,
      "disabled": !_vm.lookIf,
      "label-position": "right",
      "options": _vm.List
    },
    on: {
      "on-change": function($event) {
        _vm.Listchange('zwbdhz')
      }
    },
    model: {
      value: (_vm.zwbdhz),
      callback: function($$v) {
        _vm.zwbdhz = $$v
      },
      expression: "zwbdhz"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconArry.zwbdhzIcon),
      expression: "iconArry.zwbdhzIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1), _vm._v(" "), _c('group-title', [_vm._v("5.是否是湖北及其他中高风险地区返蓉人员？")]), _vm._v(" "), _c('div', {
    staticClass: "relative"
  }, [_c('checklist', {
    staticClass: "checklist2",
    attrs: {
      "max": 1,
      "disabled": !_vm.lookIf,
      "label-position": "right",
      "options": _vm.List
    },
    on: {
      "on-change": function($event) {
        _vm.Listchange('hbfrry')
      }
    },
    model: {
      value: (_vm.hbfrry),
      callback: function($$v) {
        _vm.hbfrry = $$v
      },
      expression: "hbfrry"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconArry.hbfrryIcon),
      expression: "iconArry.hbfrryIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1), _vm._v(" "), _c('group-title', [_vm._v("6.您当前的体温是多少？")]), _vm._v(" "), _c('flexbox', [_c('flexbox-item', {
    staticClass: "relative",
    attrs: {
      "span": 10
    }
  }, [_c('x-input', {
    staticClass: "inputClick",
    attrs: {
      "text-align": "left",
      "title": "体温",
      "readonly": !_vm.lookIf,
      "placeholder": "请填写体温"
    },
    on: {
      "on-change": _vm.xiaoshudianchange,
      "on-blur": _vm.tiwenyanzheng
    },
    model: {
      value: (_vm.basedata.dqtw),
      callback: function($$v) {
        _vm.$set(_vm.basedata, "dqtw", $$v)
      },
      expression: "basedata.dqtw"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconArry.dqtwIcon),
      expression: "iconArry.dqtwIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1), _vm._v(" "), _c('flexbox-item', [_vm._v("\n        ℃\n      ")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0",
      "padding": "0 15px",
      "font-size": "16px"
    }
  }, [_c('check-icon', {
    attrs: {
      "value": _vm.argge
    },
    on: {
      "update:value": function($event) {
        _vm.argge = $event
      }
    }
  }, [_vm._v("我已阅读本申报卡所列事项，并确认以上申报内容准确真实,因不实申报引起的不良后果自行承担相应责任。")])], 1), _vm._v(" "), _c('grid', {
    attrs: {
      "show-lr-borders": false
    }
  }, [_c('grid-item', [_c('datetime', {
    attrs: {
      "readonly": "",
      "format": "YYYY-MM-DD",
      "title": "填报日期"
    },
    model: {
      value: (_vm.txrq),
      callback: function($$v) {
        _vm.txrq = $$v
      },
      expression: "txrq"
    }
  })], 1)], 1), _vm._v(" "), (_vm.lookIf) ? _c('flexbox', {
    staticClass: "btnGroup"
  }, [_c('flexbox-item', [_c('x-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.submitdisabled
    },
    nativeOn: {
      "click": function($event) {
        _vm.sureClick($event)
      }
    }
  }, [_vm._v("提 交")])], 1), _vm._v(" "), _c('flexbox-item', [_c('x-button', {
    attrs: {
      "type": "default"
    },
    nativeOn: {
      "click": function($event) {
        _vm.colse($event)
      }
    }
  }, [_vm._v("取 消")])], 1)], 1) : _vm._e()], 1) : _c('div', {
    staticStyle: {
      "padding": "0 5px",
      "font-size": "16px",
      "color": "red",
      "text-align": "justify"
    }
  }, [_vm._v("\n    就诊人员个人健康情况申报卡的填写时间为每天07：00至20：00，其它时间不可填写！\n  ")]), _vm._v(" "), _c('toast', {
    attrs: {
      "type": "text",
      "time": 1200,
      "width": "18em",
      "is-show-mask": "",
      "text": _vm.toastTxt,
      "position": "middle"
    },
    model: {
      value: (_vm.toastShow),
      callback: function($$v) {
        _vm.toastShow = $$v
      },
      expression: "toastShow"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d32537c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/activitiesProject/healthReporting.vue
// module id = qIeP
// module chunks = 7